// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { FilterActions_updateUrlWithMapData } from 'app/shared/flux/actions/FilterActions';

// Components
import VisuallyHidden from 'app/shared/modules/VisuallyHidden';
import NearbyAreaListings from 'app/shared/modules/MobileSRP/ListingCards/NearbyAreaListings';
import AlertsButton from 'app/shared/modules/MobileSRP/ListingCards/ListingHeader/AlertsButton';
import FilterPills from 'app/shared/modules/MobileSRP/ListingCards/FilterPills';

// Icons
import IconHouseOutlined from 'images/icons/house-outlined.min.svg';
import IconPlus from 'images/icons/plus.min.svg';

// Misc / utils
import { filterUtils_hasActiveFilters } from 'app/shared/utils/filterUtils';
import gmapUtils from 'app/client/utils/map/gmapUtils';
import * as S from './styles';

const NoListingsFound = ({ handleInitializeMapClick }) => {
  // Redux
  const dispatch = useDispatch();
  const query = useSelector((state) => state.location.current.query);
  const areaName = useSelector((state) => state.area.area.name);
  const filter = useSelector((state) => state.filter);

  useEffect(() => {
    handleInitializeMapClick();
  }, []);

  const makeNoListingsTitle = () => {
    const hasActiveFilters = filterUtils_hasActiveFilters(filter);
    const isBorderDrawn = query.border !== false;

    if (hasActiveFilters) {
      return 'No properties fit your criteria.';
    } else {
      if (isBorderDrawn) {
        return 'No listings found';
      } else {
        return `No properties available in ${areaName} at the moment.`;
      }
    }
  };

  const noListingsTitle = makeNoListingsTitle();

  const handleWidenButtonClick = () => {
    const mapData = gmapUtils.getMapData(window.map);
    mapData.border = false;
    dispatch(FilterActions_updateUrlWithMapData(mapData));
  };

  return (
    <>
      <S.FlexArticle>
        <VisuallyHidden role="status" aria-live="polite">
          No listings found for {areaName}
        </VisuallyHidden>
        <S.NoListingsIcon src={IconHouseOutlined} width="100px" height="100px" alt="No listings found" />
        <S.NoListingsFoundText>{noListingsTitle}</S.NoListingsFoundText>
        <FilterPills />
      </S.FlexArticle>
      <S.FlexArticle>
        <S.WidenText>Expand your search by adding areas?</S.WidenText>
        <S.WidenSearchButton icon={IconPlus} iconWidth="14px" iconHeight="14px" onClick={handleWidenButtonClick}>
          Widen search outside of <S.BoldText>{areaName}</S.BoldText>
        </S.WidenSearchButton>
      </S.FlexArticle>
      <NearbyAreaListings currentAreaName={areaName} />
      <S.AlertArticle>
        <S.AlertText>Set up an alert to be notified as soon as a place is available in {areaName}.</S.AlertText>
        <AlertsButton />
      </S.AlertArticle>
    </>
  );
};

export default NoListingsFound;
